"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDUCER_UPDATE_NOTIFICATION_SETTING = exports.REDUCER_GET_NOTIFICATION_SETTING = exports.REDUCER_ENABLE_BIOMETRIC_SETTING = exports.REDUCER_DELETE_BIOMETRIC_SETTING = void 0;
const REDUCER_GET_NOTIFICATION_SETTING = exports.REDUCER_GET_NOTIFICATION_SETTING = 'getNotificationSetting';
const REDUCER_UPDATE_NOTIFICATION_SETTING = exports.REDUCER_UPDATE_NOTIFICATION_SETTING = 'updateNotificationSetting';
const REDUCER_ENABLE_BIOMETRIC_SETTING = exports.REDUCER_ENABLE_BIOMETRIC_SETTING = 'enableBiometricSetting';
const REDUCER_DELETE_BIOMETRIC_SETTING = exports.REDUCER_DELETE_BIOMETRIC_SETTING = 'deleteBiometricSetting';